module.exports = __webpack_public_path__ + "static/media/datasheet_musicData_row0_googleBadge.5f5d3622.png";